import React from "react";

const Loader = () => {
    return (
        <div className="w-[60px] aspect-[4] relative top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 loader"></div>
    );
};

export default Loader;
